import { ImgHTMLAttributes, ReactNode, useState } from 'react'
import styled from '@emotion/styled'
import { Box } from 'stylewhere/components'

interface Props extends ImgHTMLAttributes<any> {
  onEmptyImageComponent?: ReactNode
  variant?: 'boxed'
  transparent?: boolean
  maxHeightContainer?: number
}

export const Image = (props: Props) => {
  const [src] = useState(props.src?.includes('assets/') ? `${process.env.PUBLIC_URL}/${props.src}` : props.src)
  const [error, seterror] = useState(!props.src)

  const onError = () => {
    if (!error) seterror(true)
  }

  const { onEmptyImageComponent, ...rest } = props
  const render = () => {
    if (error && onEmptyImageComponent) return onEmptyImageComponent
    if (error) {
      const height = rest.height ?? 100
      const width = rest.width ?? 100
      return (
        <NoImageText
          transparent={props.transparent}
          center
          style={{
            height,
            minHeight: height,
            maxHeight: height,
            maxWidth: width,
            width,
            minWidth: width,
            ...rest.style
          }}
        >
          IMAGE
          <br />
          MISSING
        </NoImageText>
      )
    }
    return (
      <ImageCore
        style={{ width: rest.width ?? 100, height: rest.height ?? 100, objectFit: 'contain' }}
        src={src}
        onError={onError}
      />
    )
  }

  return (
    <Container vcenter maxHeight={props.maxHeightContainer} variant={props.variant}>
      {render()}
    </Container>
  )
}

const Container = styled(Box)<{ variant?: 'boxed'; maxHeight?: number }>`
  border-radius: 10px;
  overflow: hidden;
  ${({ variant, maxHeight }) =>
    variant === 'boxed' &&
    ` padding: 30px 20px;
      border: 1px solid #E0E0E0;
      box-sizing: border-box;
      border-radius: 5px;
      max-height: ` +
      (maxHeight + `px` || ``) +
      `;
      align-items: center;`}
`

const ImageCore = styled.img``

const NoImageText = styled(Box)<{ transparent?: boolean }>`
  font-weight: 800;
  font-size: 10pt;
  text-align: center;
  color: rgba(0, 0, 0, 0.1);
  background-color: ${({ transparent, theme }) => (transparent ? 'transparent' : theme.background1)};
  border-radius: 10px;
  margin: auto;
`
